import React, { useState, useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { ROUTE_CONSTANTS } from "./constants/routeConstants";
import {
  SendMoney,
  History,
  TransferProcessing,
  TransferSuccessful,
  TransferFailed,
  IncomingDetails,
  OutgoingDetails,
  Settings,
  SetDefaultCard,
  ScheduledPayments,
  ScheduledDetails,
  FundingiFrame,
  EventDemo,
  BannoPlugin,
  PaymentRequests,
} from "./screens";
import { TokenSignIn, NavBar, SignOut } from "./components";
import legacy from "./legacy";
import FiBranding from "./theme/branding";
import { DataContext } from "./dataContext";
import SendSmsPage from "./screens/SendSmsPage";

const {
  BANNO_PLUGIN,
  SIGN_OUT,
  TOKEN_SIGN_IN,
  HISTORY_PAGE,
  OUTGOING_DETAILS,
  INCOMING_DETAILS,
  PAYMENT_REQUEST_DETAIL,
  MAIN_PAGE,
  SETTINGS,
  SET_DEFAULT_ACCOUNT,
  PAYMENT_REQUESTS,
  TRANSFER_SUCCESSFUL,
  TRANSFER_FAILED,
  TRANSFER_PROCESSING,
  FUNDING,
  FUNDING_SIGN_IN,
  EVENT_DEMO,
  SCHEDULE_PAYMENT,
  SCHEDULED_PAYMENTS,
  SCHEDULED_DETAILS,
  SEND_SMS_PAGE,
} = ROUTE_CONSTANTS;

const AppRouter = () => {
  const { branding, dropDownStyle, dropDownTheme } = FiBranding();
  const { loggedIn, fundingToken, p2pConfig } = useContext(DataContext);

  // Visual refresh is a per-FI feature flag (fi_branding.enable_sending_ui_refresh).
  // Off (the default) renders the frozen pre-refresh screens in src/legacy.
  const refreshScreens = {
    NavBar,
    SendMoney,
    History,
    TransferProcessing,
    TransferSuccessful,
    TransferFailed,
    IncomingDetails,
    OutgoingDetails,
    Settings,
    ScheduledPayments,
    ScheduledDetails,
    PaymentRequests,
  };
  const UI =
    branding?.enable_sending_ui_refresh === true ? refreshScreens : legacy;
  const [fromDemoPage, setFromDemoPage] = useState(false);

  let homePath = MAIN_PAGE;

  if (fromDemoPage) {
    homePath = EVENT_DEMO;
  }

  return (
    <>
      {loggedIn ? (
        <>
          <UI.NavBar branding={branding} homePath={homePath} />
          <Routes>
            {[TOKEN_SIGN_IN, FUNDING_SIGN_IN].map((path) => (
              <Route path={path} key={path} element={<TokenSignIn />} />
            ))}
            <Route
              path={MAIN_PAGE}
              element={
                <UI.SendMoney
                  dropDownStyle={dropDownStyle}
                  dropDownTheme={dropDownTheme}
                  setFromDemoPage={setFromDemoPage}
                  isScheduled={false}
                  branding={branding}
                />
              }
            />
            {p2pConfig.scheduled_recurring_enabled && (
              <>
                <Route
                  path={SCHEDULE_PAYMENT}
                  element={
                    <UI.SendMoney
                      dropDownStyle={dropDownStyle}
                      dropDownTheme={dropDownTheme}
                      setFromDemoPage={setFromDemoPage}
                      isScheduled={true}
                      branding={branding}
                    />
                  }
                />
                <Route
                  path={SCHEDULED_PAYMENTS}
                  element={<UI.ScheduledPayments />}
                />
                <Route
                  path={SCHEDULED_DETAILS}
                  element={<UI.ScheduledDetails />}
                />
              </>
            )}
            <Route path={HISTORY_PAGE} element={<UI.History />} />
            <Route
              path={TRANSFER_PROCESSING}
              element={
                <UI.TransferProcessing branding={branding} homePath={homePath} />
              }
            />
            <Route
              path={TRANSFER_SUCCESSFUL}
              element={
                <UI.TransferSuccessful branding={branding} homePath={homePath} />
              }
            />
            <Route
              path={TRANSFER_FAILED}
              element={<UI.TransferFailed homePath={homePath} />}
            />
            <Route
              path={OUTGOING_DETAILS}
              element={
                <UI.OutgoingDetails branding={branding} homePath={homePath} />
              }
            />
            <Route
              path={INCOMING_DETAILS}
              element={
                <UI.IncomingDetails
                  homePath={homePath}
                  branding={branding}
                  dropDownStyle={dropDownStyle}
                  dropDownTheme={dropDownTheme}
                />
              }
            />
            <Route
              path={PAYMENT_REQUEST_DETAIL}
              element={
                <UI.IncomingDetails
                  homePath={homePath}
                  branding={branding}
                  dropDownStyle={dropDownStyle}
                  dropDownTheme={dropDownTheme}
                />
              }
            />
            <Route
              path={PAYMENT_REQUESTS}
              element={<UI.PaymentRequests />}
            />
            <Route path={SETTINGS} element={<UI.Settings />} />
            <Route path={SET_DEFAULT_ACCOUNT} element={<SetDefaultCard />} />
            {fundingToken && (
              <Route
                path={FUNDING}
                element={<FundingiFrame branding={branding} />}
              />
            )}
            {branding.event_demo && (
              <Route
                path={EVENT_DEMO}
                element={<EventDemo setFromDemoPage={setFromDemoPage} />}
              />
            )}
            <Route path={SEND_SMS_PAGE} element={<SendSmsPage />} />
            <Route path={BANNO_PLUGIN} element={<BannoPlugin />} />
            <Route path={SIGN_OUT} element={<SignOut />} />
            <Route
              path="/*"
              element={<h3 className="center_page">Page Not Found</h3>}
            />
          </Routes>
        </>
      ) : (
        <Routes>
          {[TOKEN_SIGN_IN, FUNDING_SIGN_IN].map((path) => (
            <Route
              path={path}
              key={path}
              element={<TokenSignIn branding={branding} />}
            />
          ))}
          <Route path={SIGN_OUT} element={<SignOut />} />
          <Route path={BANNO_PLUGIN} element={<BannoPlugin />} />
          <Route path={SEND_SMS_PAGE} element={<SendSmsPage />} />
          <Route
            path="/*"
            element={
              <div className="center_page">
                <div>
                  <h3>You are not registered to use this service</h3>
                  <h4>Please contact support for assistance</h4>
                </div>
              </div>
            }
          />
        </Routes>
      )}
    </>
  );
};

export default AppRouter;
